import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth/guards/auth.guard';
import { ROUTE_SEGMENTS } from '@core/constants/app-routes';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: ROUTE_SEGMENTS.DASHBOARD },
  {
    path: ROUTE_SEGMENTS.AUTH,
    loadChildren: () => import('@auth/auth-module').then((m) => m.AuthModule),
  },
  {
    path: ROUTE_SEGMENTS.DASHBOARD,
    canActivate: [AuthGuard],
    loadChildren: () => import('@dashboard/dashboard-module').then((m) => m.DashboardModule),
  },
  {
    path: ROUTE_SEGMENTS.PATIENTS,
    canActivate: [AuthGuard],
    loadChildren: () => import('@patient/patient-module').then((m) => m.PatientModule),
  },
  {
    path: ROUTE_SEGMENTS.ORGANIZATION,
    canActivate: [AuthGuard],
    loadChildren: () => import('@organization/organization-module').then((m) => m.OrganizationModule),
  },
  {
    path: ROUTE_SEGMENTS.DOCTORS,
    canActivate: [AuthGuard],
    loadChildren: () => import('@doctor/doctor-module').then((m) => m.DoctorModule),
  },
  {
    path: ROUTE_SEGMENTS.APPOINTMENTS,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/appointment/appointment.module').then((m) => m.AppointmentModule),
  },
  {
    path: ROUTE_SEGMENTS.BILLING,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/billing/billing-module').then((m) => m.BillingModule),
  },
  {
    path: ROUTE_SEGMENTS.PHARMACY,
    canActivate: [AuthGuard],
    loadChildren: () => import('@pharmacy/pharmacy-module').then((m) => m.PharmacyModule),
  },
  {
    path: ROUTE_SEGMENTS.PAYROLL,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/payroll/payroll-module').then((m) => m.PayrollModule),
  },
  {
    path: ROUTE_SEGMENTS.PROFILE,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: ROUTE_SEGMENTS.SETTINGS,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: ROUTE_SEGMENTS.IMPORT,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/data-import/data-import.module').then((m) => m.DataImportModule),
  },
  { path: ROUTE_SEGMENTS.WILDCARD, redirectTo: ROUTE_SEGMENTS.DASHBOARD },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
